export default __webpack_public_path__ + "static/media/24.79f1ec89.jpg";